'use es6';

import { TrialsApi } from 'self-service-api/core/api/trialApi';
import { trialStateAdapter } from 'self-service-api/adapters/trialStateAdapter';
const getTrialState = () => TrialsApi.getTrialState().then(trialState => trialStateAdapter(trialState));
export default getTrialState;